import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { useLoadingStore } from '@/store/loadingStore';
import './assets/main.scss';

const app = createApp(App);
const pinia = createPinia();

if (typeof window !== 'undefined' && !window.__alohinFetchLoadingInstalled) {
	const originalFetch = window.fetch.bind(window);

	window.fetch = async (...args) => {
		const loading = useLoadingStore(pinia);
		loading.start();

		try {
			return await originalFetch(...args);
		} finally {
			loading.finish();
		}
	};

	window.__alohinFetchLoadingInstalled = true;
}

app.use(pinia)
app.use(router);
app.mount('#app');